import { makeStyles } from '@material-ui/core/styles';
import { opacityLevelsMap, SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  chip: {
    '& .MuiChip-label, .MuiChip-deleteIcon': {
      color: TextColors.light,
    },

    '&.MuiChip-outlined': {
      borderColor: hexToRGBA(TextColors.light, opacityLevelsMap.dark[3]),
    },

    '&.is-category .MuiChip-label': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  chip: {
    '& .MuiChip-label, .MuiChip-deleteIcon': {
      color: TextColors.dark,
    },

    '&.MuiChip-outlined': {
      borderColor: hexToRGBA(TextColors.dark, opacityLevelsMap.light[3]),
    },

    '&.is-category .MuiChip-label': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    chip: {
      '&.dark-theme': darkTheme.chip,
      '&.light-theme': lightTheme.chip,
      position: 'relative',
      overflow: 'hidden',

      '&.MuiChip-root': {
        height: 34,
        borderRadius: 17,
      },

      '& > *': {
        position: 'relative',
      },

      '&.MuiChip-root, &.MuiChip-clickable, &.MuiChip-clickable:hover': {
        backgroundColor: 'transparent',
      },

      '&.is-multiple': {
        marginBottom: muiTheme.spacing(1),
      },

      '& .MuiChip-label': {
        ...muiTheme.typography.subtitle1,
        position: 'relative',
      },

      '&:not(:last-child)': {
        marginRight: muiTheme.spacing(2),
      },

      '&.MuiChip-sizeSmall': {
        '&:not(:last-child)': {
          marginRight: muiTheme.spacing(1),
        },

        '&.MuiChip-root': {
          height: 25,
          borderRadius: 12.5,
        },

        '& .MuiChip-label': {
          ...muiTheme.typography.body2,
          paddingLeft: 16,
          paddingRight: 16,
        },
      },

      '&.MuiChip-deletable': {
        paddingLeft: 12,
        paddingRight: 6,

        '& .MuiChip-label': {
          marginRight: 8,
        },

        '&:focus': {
          '& .MuiChip-deleteIcon': {
            opacity: 1,
          },

          '& .MuiChip-label': {
            opacity: 0.65,
          },
        },

        '& .MuiChip-deleteIcon': {
          opacity: 0.65,

          '&:hover': {
            opacity: 1,
          },
        },
      },

      '&:before': {
        content: '""',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: 'currentColor',
        position: 'absolute',
      },

      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },

      '&.is-hoverable': {
        '&:before': {
          opacity: '.5',
          transition: 'opacity 250ms ease-in-out',
        },

        '&:hover, &:focus': {
          '&:before': {
            opacity: '1',
          },
        },
      },
    },
  }),
  { name: 'GenChip' },
);

export default useStyles;
